import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./PaginaInicio.css";
import "./HomeworkModule.css";
import Cabecera from "../Others/Cabecera";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import PiePagina from "../Others/PiePagina";
import NavigationIcon from "../Others/NavigationIcon";
import { useData } from "./DataContext";
import {
  mostrarTareaApiAlumno,
  descargarPDFApiAlumno,
  updateCalificacionApiAlumno,
} from "./constants";

const MonitorGradeHomework = () => {
  const { data, dataClase } = useData();
  const [tareas, setTareas] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  const [status, setStatus] = useState({ type: "", text: "" });
  const navigate = useNavigate();

  const handleMostrarTareas = async (preserveStatus = false) => {
    if (!data) return;

    try {
      setLoading(true);
      if (!preserveStatus) {
        setStatus({ type: "", text: "" });
      }
      const response = await axios.get(mostrarTareaApiAlumno, {
        params: { matricula: data.matricula },
      });
      setTareas(Array.isArray(response.data) ? response.data : []);
      setLoaded(true);
    } catch (error) {
      console.error("Error al obtener las tareas:", error);
      setTareas([]);
      setLoaded(true);
      setStatus({
        type: "error",
        text: "No fue posible cargar las tareas para calificar.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDescargarTarea = async (tarea) => {
    try {
      setDownloadingId(tarea.id_archivo);
      setStatus({ type: "", text: "" });
      const response = await axios.get(
        descargarPDFApiAlumno + "?id_archivo=" + tarea.id_archivo,
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", tarea.nombre_archivo || "tarea.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar la tarea:", error);
      setStatus({
        type: "error",
        text: "No fue posible descargar la tarea. Intenta nuevamente.",
      });
    } finally {
      setDownloadingId(null);
    }
  };

  const handleCalificarTarea = async (tarea) => {
    try {
      setSavingId(tarea.id_archivo);
      setStatus({ type: "", text: "" });
      await axios.put(updateCalificacionApiAlumno, {
        id_archivo: tarea.id_archivo,
        nueva_calificacion: tarea.calificacion,
      });
      setStatus({
        type: "success",
        text: "La calificación se actualizó correctamente.",
      });
      await handleMostrarTareas(true);
    } catch (error) {
      console.error("Error al calificar la tarea:", error);
      setStatus({
        type: "error",
        text: "No fue posible actualizar la calificación.",
      });
    } finally {
      setSavingId(null);
    }
  };

  const updateGrade = (idArchivo, value) => {
    setTareas((currentTasks) =>
      currentTasks.map((task) =>
        task.id_archivo === idArchivo
          ? { ...task, calificacion: value }
          : task
      )
    );
  };

  return (
    <div className="contenedor-pagina">
      <Cabecera
        contenidosuperior={
          <BarraSuperior texto_cabecera={dataClase?.nombre_clase || "Calificar tareas"} />
        }
        contenidoInferior={<BarraInferior />}
      />

      <main className="homework-module">
        <section className="homework-panel" aria-labelledby="legacy-monitor-grade-title">
          <header className="homework-hero">
            <div>
              <span className="homework-eyebrow">Seguimiento de calificaciones</span>
              <h1 id="legacy-monitor-grade-title">Calificar tareas</h1>
              <p>
                Consulta las entregas asociadas al alumno seleccionado y
                actualiza su calificación.
              </p>
            </div>
            <div className="homework-summary">
              <strong>{tareas.length}</strong>
              <span>{tareas.length === 1 ? "entrega encontrada" : "entregas encontradas"}</span>
            </div>
          </header>

          <div className="homework-body">
            <div className="homework-form-actions">
              <button
                type="button"
                className="homework-button-ghost"
                onClick={() => navigate("/m-pagina-tareas")}
              >
                <NavigationIcon name="chevron" size={18} />
                Regresar a ejercicios
              </button>
              <button
                type="button"
                className="homework-button"
                disabled={loading}
                onClick={() => handleMostrarTareas()}
              >
                <NavigationIcon name="tasks" size={18} />
                {loading ? "Consultando..." : "Mostrar tareas"}
              </button>
            </div>

            {status.text && (
              <div
                className={"homework-status is-" + status.type}
                role={status.type === "error" ? "alert" : "status"}
              >
                {status.text}
              </div>
            )}

            {loading ? (
              <div className="homework-loading" aria-live="polite">
                <span className="homework-spinner" />
                <strong>Cargando entregas</strong>
                <p>Estamos consultando las tareas del alumno seleccionado.</p>
              </div>
            ) : loaded && tareas.length === 0 ? (
              <div className="homework-empty">
                <span className="homework-empty-icon">
                  <NavigationIcon name="deliverables" size={28} />
                </span>
                <strong>No se encontraron entregas</strong>
                <p>El alumno seleccionado todavía no tiene tareas disponibles.</p>
              </div>
            ) : !loaded ? (
              <div className="homework-empty">
                <span className="homework-empty-icon">
                  <NavigationIcon name="tasks" size={28} />
                </span>
                <strong>Consulta las tareas del alumno</strong>
                <p>Selecciona “Mostrar tareas” para cargar sus entregas.</p>
              </div>
            ) : (
              <div className="homework-legacy-list">
                {tareas.map((tarea, index) => (
                  <article
                    className="homework-legacy-card"
                    key={tarea.id_archivo || index}
                  >
                    <div className="homework-legacy-info">
                      <span className="homework-kicker">Entrega del alumno</span>
                      <h2>{tarea.nombre_archivo || "Archivo sin nombre"}</h2>
                      <p>Matrícula de clase: {tarea.matricula_clase}</p>
                    </div>
                    <div className="homework-legacy-actions">
                      <button
                        type="button"
                        className="homework-button-secondary"
                        disabled={downloadingId === tarea.id_archivo}
                        onClick={() => handleDescargarTarea(tarea)}
                      >
                        <NavigationIcon name="deliverables" size={17} />
                        {downloadingId === tarea.id_archivo
                          ? "Descargando..."
                          : "Descargar"}
                      </button>
                      <input
                        className="homework-grade-input"
                        type="number"
                        min="0"
                        max="10"
                        aria-label={"Calificación de " + tarea.nombre_archivo}
                        value={tarea.calificacion ?? ""}
                        onChange={(event) =>
                          updateGrade(tarea.id_archivo, event.target.value)
                        }
                      />
                      <button
                        type="button"
                        className="homework-button"
                        disabled={savingId === tarea.id_archivo}
                        onClick={() => handleCalificarTarea(tarea)}
                      >
                        <NavigationIcon name="final" size={17} />
                        {savingId === tarea.id_archivo
                          ? "Guardando..."
                          : "Guardar calificación"}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default MonitorGradeHomework;
